import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ProfileHeader.css';
import { openOverlay } from './OverlayActions';
import { 
  NEW_CONTRACT_LABEL,
  MESSAGE_LABEL
} from './Constants.js';
import defaultProfileImg from '../profile.svg';
import store from '../store';
import { refreshProfileData, favoriteSelect } from './ProfileHeaderActions';
import { navNewURL } from "./ActionUtils";
import FavoriteToggle from './FavoriteToggle';

class ProfileHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getSelectedUser = this.getSelectedUser.bind(this);
    this.changeDisplayname = this.changeDisplayname.bind(this);
    this.handleNewContract = this.handleNewContract.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleFavoriteClick = this.handleFavoriteClick.bind(this);
  }

  getSelectedUser(props) {
    let {
      queryParamUser=""
    } = props.profileHeader;

    let {
      username=""
    } = props.auth;

    let selectedUser = "";
    if (queryParamUser === "") {
      selectedUser = username;
    }
    else {
      selectedUser = queryParamUser;
    }

    return { queryParamUser, username, selectedUser };
  }

  componentDidMount() {
    let userObj = this.getSelectedUser(this.props);
    
    if (userObj.selectedUser !== "") {
      this.props.dispatch(refreshProfileData(userObj.selectedUser));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let userObj = this.getSelectedUser(this.props);
    let prevUserObj = this.getSelectedUser(prevProps);

    if (
      (
        userObj.selectedUser !== prevUserObj.selectedUser || 
        userObj.username !== prevUserObj.username || 
        userObj.queryParamUser !== prevUserObj.queryParamUser
      ) && 
      userObj.selectedUser !== ""
    ) {
      this.props.dispatch(refreshProfileData(userObj.selectedUser));
    }
  }

  changeDisplayname(event) {
    let {
      profileFile="",
      displayname="",
      summary=""
    } = this.props.profileHeader;

    let photoContent = "";
    if (profileFile !== "") {
      photoContent = "https://atstake.s3.amazonaws.com/" + profileFile;
    }

    store.dispatch(openOverlay("change_displayname", {displayname, summary, photoContent}));
  }

  handleNewContract(name, value) {
    let {
      selectedUser="",
    } = this.props.profileHeader;
    let loggedin = this.props.auth.status === "loggedin";

    if (loggedin) {
      this.props.dispatch(openOverlay("new_contract", {user: selectedUser}));
    }
    else {
      this.props.dispatch(openOverlay("login", {}));
    }
  }

  handleMessage(name, value) {
    let {
      selectedUser="",
    } = this.props.profileHeader;
    let loggedin = this.props.auth.status === "loggedin";
    
    if (loggedin) {
      this.props.dispatch(navNewURL('/messages?user=' + selectedUser));
    }
    else {
      this.props.dispatch(openOverlay("login", {}));
    }
  }

  handleFavoriteClick(contact, selected) {
    this.props.dispatch(favoriteSelect(contact, selected));
  }

  render() {
    
    let { 
      username="" 
    } = this.props.auth;

    let {
      selectedUser="",
      selectedTab="",
      profileFile="",
      displayname="",
      userExists="",
      //dataLoaded=false
    } = this.props.profileHeader;

    let photoSrc = "";
    if (profileFile === "") {
      photoSrc = defaultProfileImg;
    }
    else {
      photoSrc = "https://atstake.s3.amazonaws.com/" + profileFile;
    }

    let loggedin = this.props.auth.status === "loggedin";

    let { 
      favoriteSelected=false,
      favoritePending=false
    } = this.props.profileHeader;

    let ownAccount = (username === selectedUser);

    return (
      <header className="accountProfileHeader">
        <div className="accountProfileIdentity">
          <img className="accountProfilePhoto" src={photoSrc} alt="Profile" />
          <div className="accountProfileNames">
            <h1>{selectedUser || '\u00a0'}</h1>
            {userExists && displayname !== "" && <p>{displayname}</p>}
            {userExists && ownAccount && <button type="button" onClick={this.changeDisplayname} className="accountTextButton">Edit name and photo</button>}
          </div>
          {userExists && <div className="accountProfileActions">
            <button type="button" name="new_contract" className="accountPrimaryButton" onClick={this.handleNewContract}><span aria-hidden="true">＋</span> {NEW_CONTRACT_LABEL}</button>
            {!ownAccount && <button type="button" name="message" className="accountSecondaryButton" onClick={this.handleMessage}>{MESSAGE_LABEL}</button>}
            {loggedin && !ownAccount && <div className="accountProfileFavorite"><FavoriteToggle selected={favoriteSelected} pending={favoritePending} contact={selectedUser} onClick={this.handleFavoriteClick} /></div>}
          </div>}
        </div>
        <nav className="profileTabs" aria-label="Profile sections">
          {['profile', 'contracts', 'ratings'].map((page, index) => {
            const href = '/' + page + (ownAccount ? '' : '?user=' + encodeURIComponent(selectedUser));
            return <a key={page} href={href} className="profileTab" aria-current={selectedTab === page ? 'page' : undefined} onClick={event => {
              if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
              event.preventDefault();
              this.props.dispatch(navNewURL(href));
            }}>{['About', 'Contracts', 'Ratings'][index]}</a>;
          })}
        </nav>
      </header>
    );
  }
}
  
const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    menu: state.menu,
    profileHeader: state.profileHeader
  }
}

const ProfileHeaderContainer = connect(mapStateToProps, null)(ProfileHeader);
export default ProfileHeaderContainer;
